module.exports = __webpack_public_path__ + "static/img/system-2.6a96f0ed.png";